import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p
    className={`font-mono text-[11px] sm:text-xs uppercase tracking-[0.28em] font-medium ${
      light ? "text-rose-300" : "text-[#A31D4F]"
    }`}
  >
    {children}
  </p>
);

export const RevealImage = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ clipPath: "inset(10% 5% 10% 5% round 32px)", opacity: 0.35, scale: 1.05 }}
    whileInView={{ clipPath: "inset(0% 0% 0% 0% round 32px)", opacity: 1, scale: 1 }}
    viewport={{ once: true, margin: "-10%" }}
    transition={{ duration: 1.2, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);
